import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import confirmAccount from "../services/confirmAccount";
import { showSuccessMessage } from "@beeldit/core/helpers/messagesHelper";

const AccountConfirmation = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) return;

    confirmAccount(
      token,
      (data: any) => {
        if (data?.message) {
          showSuccessMessage(data.message);
        }
        navigate("/login");
      },
      (error: any) => {
        console.error("Confirmation failed:", error);
      }
    );
  }, [searchParams, navigate]);

  return null;
};

export default AccountConfirmation;
